import { render, staticRenderFns } from "./MenuBubble.vue?vue&type=template&id=48157a56&scoped=true&"
import script from "./MenuBubble.vue?vue&type=script&lang=js&"
export * from "./MenuBubble.vue?vue&type=script&lang=js&"
import style0 from "./MenuBubble.vue?vue&type=style&index=0&id=48157a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48157a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48157a56')) {
      api.createRecord('48157a56', component.options)
    } else {
      api.reload('48157a56', component.options)
    }
    module.hot.accept("./MenuBubble.vue?vue&type=template&id=48157a56&scoped=true&", function () {
      api.rerender('48157a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/MenuBubble.vue"
export default component.exports